var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepositArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 12 12)",
    fill: "#F9FBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9961 6.94824C12.3273 6.94824 12.5957 7.21821 12.5957 7.55123L12.5957 14.8961L15.9739 11.5205C16.2088 11.2858 16.5884 11.287 16.8218 11.5232C17.0552 11.7595 17.054 12.1413 16.8191 12.376L12.4187 16.773C12.1849 17.0067 11.8073 17.0067 11.5735 16.773L7.17307 12.376C6.93816 12.1413 6.93695 11.7595 7.17036 11.5232C7.40377 11.287 7.78343 11.2858 8.01833 11.5205L11.3965 14.8961L11.3965 7.55123C11.3965 7.21821 11.6649 6.94824 11.9961 6.94824Z",
    fill: "#4C4A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositArrow);
export default __webpack_public_path__ + "static/media/deposit-arrow.a426ab19.svg";
export { ForwardRef as ReactComponent };